"use strict";
import { createContext, useReducer } from "react";
import { getLocalStorageItem } from "./utils/storage.js";

export const Store = createContext();

const initialState = {
  userInfo: getLocalStorageItem("userInfo", null),
  userToken: getLocalStorageItem("userToken", {}),
  employeeTasks: getLocalStorageItem("employeeTasks", {}),
  accessToken: getLocalStorageItem("accessToken", {}),
  projectFile: getLocalStorageItem("projectFile", {}),
};

function reducer(state, action) {
  switch (action.type) {
    case "USER_SIGNIN":
      return { ...state, userInfo: action.payload };
    case "USER_SIGNOUT":
      return {
        ...state,
        userInfo: null,
        sampleCreatedData: {},
        projectFile: {},
      };

    case "SAVE_USER_TOKEN":
      return {
        ...state,
        userToken: action.payload,
      };

    case "SAVE_ACCESS_TOKEN":
      return {
        ...state,
        accessToken: action.payload,
      };

    case "EMPLOYEE_TASKS":
      return {
        ...state,
        employeeTasks: action.payload,
      };

    case "PROJECT_FILE":
      return {
        ...state,
        projectFile: action.payload,
      };

    case "PROJECT_FILE_CLEAR":
      return {
        ...state,
        projectFile: {},
      };

    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}

